
import { Vue } from "vue-class-component"; //基本需要\
import * as echarts from "echarts";
import html2canvas from "html2canvas";
import { flamegraph } from "d3-flame-graph";
import * as d3 from "d3";
import {
  dispatchDeepPerformanceCpuCpuThreads,
  dispatchDeepPerformanceCpuCpuVersions,
  dispatchDeepPerformanceCpuCpuVersionsOld,
  dispatchDeepPerformanceCpuCpuByFrame,
  dispatchDeepPerformanceCpuStack,
  dispatchDeepPerformanceCpuFunctionCos,
  dispatchGetDeepPerformanceSelectOptionsOld,
  dispatchDeepPerformanceCpuFuncReport,
  dispatchUploadCpuReport,
  dispatchDeepPerformanceFlameGraphUrl,
  dispatchDeepPerformanceCpuDetail,
  dispatchDeepPerformanceCpuStackMerge,
  dispatchDeepPerformanceTrendNode,
} from "@/store/performance/actions";
import { readDeepPerformanceSelectOptionsOld } from "@/store/performance/getters";
import { store } from "@/store";
import {
  readGetdeepCpuThreads,
  readGetdeepCpuVersions,
  readGetdeepCpuVersionsOld,
  readGetdeepFlameUrl,
  readGetdeepCpuByFrame,
  readGetdeepCpuStack,
  readGetdeepCpuFunctionCos,
  readGetDeepCpuFuncReport,
  readGetdeepCpuDetail,
  readGetdeepTrendNode,
} from "@/store/performance/getters"; //引入仓库接口
import { compare, dateConversion, getLocalProject } from "@/utils";

import { read } from "xlsx";
import { ref } from "vue";
export default class TestReport extends Vue {
  public localProject = Number(getLocalProject());
  public name_search = "";
  public dataConsumeOptions = {
    version: "",
    device: 0,
    scene: 0,
    old_verson: "",
    id_test: "",
    thread: "",
    subScene: "",
    old_test: "",
    so: "",
  };
  public flag = false;
  public dataLoading = false;
  public threadLoading = false;
  public stackLoading = false;
  public getChinese(i) {
    if (i === "single_frame_time") {
      return "单帧平均耗时(ms)";
    } else {
      return i;
    }
  }
  public save_report(is_auto?: boolean) {
    this.resBase64 = [];
    let list = ["bdIframe", "func"];

    this.$nextTick(() => {
      this.htmlCanvas("bdIframe");
    });

    let old_test = this.versionsOldOptions.filter(
      (v) => v.chinese === this.dataConsumeOptions.old_verson
    )[0].id_test;
    // if (typeof is_auto === "boolean") {
    //   upload_data = {
    //     project: this.localProject,
    //     id_test: Number(this.dataConsumeOptions.id_test),
    //     old_test: old_test,
    //     thread: this.dataConsumeOptions.thread,
    //     so: this.dataConsumeOptions.so,
    //     file_list: this.resBase64,
    //     title: this.formMail.title,
    //     recv: this.formMail.addressee,
    //     cc: this.formMail.CC_List,

    //     send: this.formMail.Sender,
    //   };
    // } else {
    //   upload_data = {
    //     // project: Number(this.$route.query.project),
    //     project: this.localProject,
    //     id_test: Number(this.dataConsumeOptions.id_test),
    //     old_test: old_test,
    //     thread: this.dataConsumeOptions.thread,
    //     so: this.dataConsumeOptions.so,
    //     file_list: this.resBase64,
    //     title: this.formMail.title,
    //     recv: this.formMail.addressee,
    //     cc: this.formMail.CC_List,

    //     send: this.formMail.Sender,
    //   };
    // }
    // dispatchUploadCpuReport(store, upload_data);
    // ElMessage({
    //   //Message 消息提示
    //   message: "报告发送中...",
    //   showClose: true,
    // });
    // this.edit = false;
  }
  public resBase64 = [];
  public hexToRgb(hex) {
    var rgb = [];
    for (var i = 1; i < 7; i += 2) {
      rgb.push(parseInt("0x" + hex.slice(i, i + 2)));
    }
    return rgb;
  }
  public get details_list() {
    let list: any = [];
    list = [
      { label: "func_name", prop: "name" },
      { label: "Time(ms)", prop: "value" },
      { label: "Time(%)", prop: "rate" },
    ];
    return list;
  }
  public affirmBtn() {
    // this.le=90
    this.dataLoading = true;
    // this. selectShow=false, //控制框选文字
    //     this.currentPage = 1;
    //   this.coordRange = []; //
    //   this. trendInex =0
    //      this.serch = "";

    //   this.makLineShow = true;
    //   this.flame_serch=''
    this.resBase64 = [];
    let date = this.version_list.filter(
      (v) => v.chinese == this.dataConsumeOptions.version
    )[0].date;
    let version = this.version_list.filter(
      (v) => v.chinese == this.dataConsumeOptions.version
    )[0].game_version;
    this.dataConsumeOptions.id_test = this.version_list.filter(
      (v) => v.chinese == this.dataConsumeOptions.version
    )[0].id_test;
    let old_test = this.versionsOldOptions.filter(
      (v) => v.chinese === this.dataConsumeOptions.old_verson
    )[0].id_test;
    dispatchDeepPerformanceCpuDetail(store, {
      project: this.localProject,
      id_test: this.dataConsumeOptions.id_test,
    });
    dispatchDeepPerformanceFlameGraphUrl(store, {
      project: this.localProject,
      id_test: Number(this.dataConsumeOptions.id_test),
    });
    if (this.detail) {
      let report_settings = JSON.parse(readGetdeepCpuDetail(store).settings);
      this.report_settings_threshold = report_settings.threshold.change;
      this.report_settings_threshold_abs = report_settings.threshold.abs;
    }
    if (this.flag === true) {
      this.threadLoading = true;
      this.startValue = 0;
      this.endValue = 100;
      this.stackLoading = true;
      (this.selectShow = false), //控制框选文字
        (this.currentPage = 1);
      this.coordRange = []; //
      this.trendInex = 0;
      this.serch = "";

      this.makLineShow = true;
      dispatchDeepPerformanceCpuCpuByFrame(store, {
        project: this.localProject,
        date: date,
        device_id: Number(this.dataConsumeOptions.device),
        scene_id: Number(this.dataConsumeOptions.scene),
        version: version,
        id_test: this.dataConsumeOptions.id_test,
        thread: this.dataConsumeOptions.thread,
      }).then((res) => {
        this.labels;
        this.series();
        this.$nextTick(() => {
          this.drawAnalyseTrend();
        });
        this.getFramesInfo(this.trendInex, this.trendInex);
        this.threadLoading = false;
        this.testShow = false;
        dispatchDeepPerformanceCpuStack(store, {
          project: this.localProject,
          id_test: Number(this.dataConsumeOptions.id_test),
          frame: this.month,
          thread: this.threadOptions,
        }).then((res) => {
          this.testShow = true;
          this.tableList = this.getTop10(this.stackData_obj).slice(1, 101);
          this.tableList.forEach((v) => {
            if (this.localProject == 34) {
              if (
                v.name === "UnityMain" ||
                v.name === "CoreThread" ||
                v.name === "UnityGfx" ||
                v.name === "NativeThread" ||
                v.name === "Worker Thread"
              ) {
                v.check = true;
              } else {
                v.check = false;
              }
            } else {
              if (v.name === "GameThread" || v.name === "RenderThread") {
                v.check = true;
              } else {
                v.check = false;
              }
            }
          });
          this.tableList_new = this.tableList.slice(
            (this.currentPage - 1) * 10,
            this.currentPage * 10
          );
          this.total = this.tableList.length;
          (this.$refs.table as any).toggleRowExpansion(
            this.stackData_all[0],
            true
          );
          this.renderFlame("#chart", this.stackData_obj);
          // let c = (this.$refs.iframeDom as any).contentWindow;

          // setTimeout(() => {
          //   c.postMessage(
          //     {
          //       cmd: JSON.stringify(this.stackData_obj),
          //       apiUrl: 3,
          //       params: {},
          //     },
          //     "*"
          //   );
          // }, 200);
          // let iframe: any = document.getElementById("bdIframe");
          // window.addEventListener("message", (e) => {
          //   let data = e.data;

          //   iframe.height = Number(data.c) + 20 + "px";
          // });

          this.stackLoading = false;
        });
      });
      this.flag = false;
    } else {
      this.$nextTick(() => {
        this.drawAnalyseTrend();
      });
    }

    dispatchDeepPerformanceCpuFuncReport(store, {
      project: this.localProject,
      id_test: Number(this.dataConsumeOptions.id_test),
      old_test: old_test,
      thread: this.dataConsumeOptions.thread,
      so: this.dataConsumeOptions.so,
    }).then((res) => {
      this.get_data();
      this.risk_description = [];
      this.text_list = {};
      let list = [];
      let indexList = [];
      this.get_core_data.func_list.data.forEach((v) => {
        if (v.type == "thread") {
          list.push(v.name);
        }
      });

      list.forEach((v) => {
        let index = this.get_core_data.func_list.data.findIndex(
          (k) => k.name === v
        );

        indexList.push(index);
      });

      for (let i = 0; i < indexList.length; i++) {
        this.text_list[list[i]] = this.get_core_data.func_list.data.slice(
          indexList[i] + 1,
          indexList[i + 1]
        );
      }

      for (let i in this.text_list) {
        let list = this.text_list[i].filter((v) => {
          return v.type !== "so";
        });
        this.text_list[i] = list;
      }
      for (let i in this.text_list) {
        if (this.findValue(i)[3] != true) {
          delete this.text_list[i];
        }
        // let list=this.text_list[i].filter(v=>{
        //   return this.findValue(v.name)[3]===true

        // })
        // this.text_list[i]=list
        // let three=this.text_list[i].filter((v,index)=>{
        //  return  index<=2
        // })
        // this.text_list[i]=three
      }
      for (let i in this.text_list) {
        let list = this.text_list[i].filter((v) => {
          return this.findValue(v.name)[3] === true;
        });
        this.text_list[i] = list;
        let three = this.text_list[i].filter((v, index) => {
          return index <= 2;
        });
        this.text_list[i] = three;
      }
      let cpu_list_thead = this.params.slice(2, 10);
      let cpu_list = [];
      cpu_list_thead.forEach((v) => {
        cpu_list.push({
          name: v.name,
          new: this.get_core_data.cpu_usage_list[0].new[v.value]
            ? this.get_core_data.cpu_usage_list[0].new[v.value]
            : "",
          old: this.get_core_data.cpu_usage_list[0].old[v.value]
            ? this.get_core_data.cpu_usage_list[0].old[v.value]
            : "",
        });
      });
      this.cpu_list = cpu_list.filter(
        (v) => this.com_num_color5(v.new, "cpu", v.name) == "red"
      );
      // CPU数据结束
      // 线程数据
      this.thread_list = this.get_core_data.func_list.data.filter(
        (v) => v.type == "thread"
      );
      this.risk_description.push({
        device:
          this.get_core_data.basic.device_name +
          "-" +
          this.get_core_data.basic.device_level,
        scene: this.get_core_data.basic.scene,
        risk: "",
      });
      this.overList = Object.keys(this.get_core_data?.overview[0].new);
      this.target.forEach((v, index) => {
        this.$nextTick(() => {
          this.drawTrends(v.value, index, v.title);
        });
      });
      this.$router.push({
        query: {
          ...this.$route.query,
          id_test: this.dataConsumeOptions.id_test,
          old_test: old_test,
          thread: this.dataConsumeOptions.thread,

          so: this.dataConsumeOptions.so,
        },
      });
      this.dataLoading = false;
      this.flag = false;
    });
  }
  public async versionChange(item, type) {
    let date = this.version_list.filter(
      (v) => v.chinese == this.dataConsumeOptions.version
    )[0].date;
    let version = this.version_list.filter(
      (v) => v.chinese == this.dataConsumeOptions.version
    )[0].game_version;
    this.dataConsumeOptions.id_test = this.version_list.filter(
      (v) => v.chinese == this.dataConsumeOptions.version
    )[0].id_test;
    let deivce_fil = this.version_list.filter(
      (v) => v.chinese == this.dataConsumeOptions.version
    )[0].device_id;
    let scene_fil = this.version_list.filter(
      (v) => v.chinese == this.dataConsumeOptions.version
    )[0].scene_id;

    for (let v of item) {
      if (v == "version") {
        this.flag = true;

        await dispatchGetDeepPerformanceSelectOptionsOld(store, {
          project: this.localProject,
          date: date,
          game_version: version,
        });

        this.dataConsumeOptions.device = deivce_fil;

        this.dataConsumeOptions.scene = scene_fil;
      }
      if (v == "scene") {
        this.flag = true;
        await dispatchDeepPerformanceCpuCpuVersionsOld(store, {
          project: this.localProject,
          device_id: Number(this.dataConsumeOptions.device),
          scene_id: Number(this.dataConsumeOptions.scene),
          type: "",
          subtype: "",
          is_auto: "",
        });
        this.dataConsumeOptions.old_verson =
          this.versionsOldOptions.length > 1
            ? this.versionsOldOptions[1].chinese
            : this.versionsOldOptions[0].chinese;
        this.version_list = this.versionsOldOptions;
        this.dataConsumeOptions.version = this.versionsOldOptions[0].chinese;
      }

      if (v == "thread") {
        this.flag = true;
        await await dispatchDeepPerformanceCpuCpuThreads(store, {
          project: this.localProject,

          id_test: this.dataConsumeOptions.id_test,
        });
        this.dataConsumeOptions.thread = this.threadOptions[0];
      }
      if (v === "so") {
        this.flag = true;
        await dispatchDeepPerformanceCpuFunctionCos(store, {
          project: this.localProject,
          thread: this.dataConsumeOptions.thread,
          id_test: this.dataConsumeOptions.id_test,
        });
        this.dataConsumeOptions.so = this.cpu_function_cos[0];
      }
    }
  }
  public get stackData() {
    let list = [];
    let list1 = [];
    let list2 = [];
    if (JSON.stringify(readGetdeepCpuStack(store)) != "{}") {
      list.push({});
      list[0] = JSON.parse(JSON.stringify(readGetdeepCpuStack(store)));

      list.forEach((v) => {
        if (v.children.length > 0) {
          v.is_expand = true;
        } else {
          v.is_expand = false;
        }
      });
      list.map((e) => {
        delete e.children;
      });
      list1.push(readGetdeepCpuStack(store));
      // list.push({})
    }

    return list;
  }
  public get stackData_all() {
    let list = [];
    let list1 = [];
    let list2 = [];
    if (JSON.stringify(readGetdeepCpuStack(store)) != "{}") {
      list.push({});
      list[0] = JSON.parse(JSON.stringify(readGetdeepCpuStack(store)));

      list1.push(readGetdeepCpuStack(store));
      // list.push({})
    }

    return list;
  }
  public get stackData_obj() {
    let list = {};

    if (JSON.stringify(readGetdeepCpuStack(store)) != "{}") {
      list = readGetdeepCpuStack(store);

      // list.push({})
    }

    return list;
  }
  public find = (v, list) => {
    let data;
    (list || []).map((i) => {
      if (i.id === v) {
        if (i.children) {
          data = i.children;
          data.forEach((m) => {
            if (m.children.length > 0) {
              m.is_expand = true;
            } else {
              m.is_expand = false;
            }
          });
        }

        // data.map(e => { delete e.children })
      } else {
        const child = this.find(v, i.children);

        if (child) {
          data = child;
        }
      }
    });

    return data;
  };

  public async load(
    row: any,
    treeNode: unknown,
    resolve: (date: any[]) => void
  ) {
    // this.find(row.id,this.stackData_all)
    // await dispatchDeepPerformanceCpuStackCreatedOld(store,{
    //     project: this.localProject,
    //   id_test: Number(readGetdeepCpuByFrame(store).id_test),
    //   frame: this.abs_time,
    //   depth:row.depth,
    //   id_row:row.id_row,
    //   thread:row.thread_hash_id,
    //   abs_time:this.month,
    // })
    //  let childrenListArray = readGetdeepCpuStackCreatOld(store);
    await setTimeout(() => {
      resolve(this.find(row.id, this.stackData_all));
    }, 1000);
  }
  public rgbToHex(r: any, g: any, b: any) {
    var hex = ((r << 16) | (g << 8) | b).toString(16);
    return "#" + new Array(Math.abs(hex.length - 7)).join("0") + hex;
  }
  public gradient(startColor, endColor, step) {
    // 将 hex 转换为rgb
    var sColor = this.hexToRgb(startColor),
      eColor = this.hexToRgb(endColor);

    // 计算R\G\B每一步的差值
    var rStep = (eColor[0] - sColor[0]) / step;
    var gStep = (eColor[1] - sColor[1]) / step;
    var bStep = (eColor[2] - sColor[2]) / step;

    var gradientColorArr = [];
    for (var i = 0; i < step; i++) {
      // 计算每一步的hex值
      gradientColorArr.push(
        this.rgbToHex(
          parseInt(rStep * i + sColor[0]),
          parseInt(gStep * i + sColor[1]),
          parseInt(bStep * i + sColor[2])
        )
      );
    }
    return gradientColorArr;
  }
  public tableRowClassName(row: any) {
    let num = Math.round(row.row.value);
    var startColor = "#3E3E3E";
    var endColor = "#6E2F2F";
    var colorArr = this.gradient(
      startColor,
      endColor,
      Math.round(this.stackData[0].value)
    );
    if (num == Math.round(this.stackData[0].value)) {
      num = Math.round(this.stackData[0].value) - 1;
    }

    // console.log(colorArr[num])
    return {
      background: colorArr[num],
      borderBottom: "0",
      color: "#fff",
      height: "2px",
    };
  }
  public getName(item, i) {
    if (item.indexOf("_") != -1) {
      return item.split("_")[0];
    } else {
      return item;
    }
  }
  public get cpu_by_frame_list() {
    let list = JSON.parse(JSON.stringify(readGetdeepCpuByFrame(store)));
    let list1 = [];
    list.labels.forEach((v, index) => {
      list1.push(v.map((k) => k + "_" + index));
    });

    return list1;
  }
  public los(data) {
    return data;
  }
  public getNum(item1, item2) {
    if (item1 === "" || item2 == null || item2 == "--") {
      return "--";
    }

    if (item1 > item2) {
      return (item1 - item2).toFixed(2) + "↑";
    } else if (item1 < item2) {
      return (item2 - item1).toFixed(2) + "↓";
    }
    if (item1 === item2) {
      return "--";
    }
  }
  public depth(num) {
    return num * 10;
  }
  public chart = ref(null);
  public params = [
    { name: "Total%", value: "avg_cpu_total" },
    { name: "App%", value: "avg_cpu" },
    { name: "CPU0%", value: "cpu_usage_0" },
    { name: "CPU1%", value: "cpu_usage_1" },
    { name: "CPU2%", value: "cpu_usage_2" },
    { name: "CPU3%", value: "cpu_usage_3" },
    { name: "CPU4%", value: "cpu_usage_4" },
    { name: "CPU5%", value: "cpu_usage_5" },
    { name: "CPU6%", value: "cpu_usage_6" },
    { name: "CPU7%", value: "cpu_usage_7" },
    { name: "Freq MHz", value: "avg_cpu_freq" },
  ];

  public get_url(url: string) {
    let new_url = url;
    if (url) {
      let url_arr = url.split("/");
      if (url_arr[2] !== "runmax.oa.com") {
        let current_herf = window.parent.location.href;
        let f = current_herf.split("/");
        let domain = f[2];
        url_arr[2] = domain;
        new_url = url_arr.join("/");
        return new_url;
      }
    }
    return url;
  }
  public get_data() {
    this.get_core_data = readGetDeepCpuFuncReport(store);
  }
  public get_core_data: any = {
    basic: {
      version: "",
      old_version: "",
      url: "",
      device_name: "",
      device_level: "",
      scene: "",
    },
    cpu_usage_list: [],
    func_list: {
      data: [{ list: [] }],
    },
    risk_rule: "",
    tdr_risk_rule: 0,
    module_trend: {},
    overview: [],
    thread_trend: [],
  };
  public formMail = {
    title: "", //标题
    Sender: "gamerobot@tencent.com", //发件人
    addressee: "", //收件人
    CC_List: "", //抄送人
  };
  public edit = false;
  public sendOut() {
    this.edit = !this.edit;
  }
  public overList = [];
  public risk_description = [];
  public version_list = [];
  public versionsOptions() {
    this.version_list = readGetdeepCpuVersions(store).data;
    return this.version_list;
  }
  public get versionsOldOptions() {
    return readGetdeepCpuVersionsOld(store).data;
  }
  public get device_options_old() {
    const devices = this.performace_select_options_old.device_list;

    return devices;
  }
  public get performace_select_options_old() {
    const options = readDeepPerformanceSelectOptionsOld(store);

    return options;
  }
  public get scene_options_old() {
    const scene_list: any[] = this.performace_select_options_old.scene_list;

    return scene_list;
  }
  public get threadOptions() {
    return readGetdeepCpuThreads(store).data;
  }
  public get cpu_function_cos() {
    return readGetdeepCpuFunctionCos(store).data;
  }
  public get detail() {
    return readGetdeepCpuDetail(store);
  }
  public com_num_color5(item, type, i) {
    if (i.indexOf("%") != -1) {
      if (typeof item == "number") {
        if (item > this.report_settings_threshold_abs[type] * 100) {
          return "red";
        } else {
          return "#606266";
        }
      }
    } else {
      return "#606266";
    }
  }
  serchChange() {
    this.currentPage = 1;
    let list = this.tableList.filter((v) => {
      return v.name.toUpperCase().includes(this.serch.toUpperCase());
    });

    this.total = list.length;
    this.tableList_new = list.slice(
      (this.currentPage - 1) * 10,
      this.currentPage * 10
    );
  }
  public com_num_color3(item, item2, type, i) {
    if (type) {
      if (typeof item == "number" && typeof item2 == "number") {
        if (i.indexOf("%") != -1) {
          if (
            Math.abs(item - item2) >
            this.report_settings_threshold[type] * 100
          ) {
            if (item > item2) {
              if (i === "FPS") {
                return "#00b050";
              } else {
                return "red";
              }
            }
            if (item < item2) {
              if (i === "FPS") {
                return "red";
              } else {
                return "#00b050";
              }
            }
          }
        } else {
          if ((this.report_settings_threshold as any).freq) {
            if (
              Math.abs(item - item2) / item2 >
              (this.report_settings_threshold as any).freq
            ) {
              if (item > item2) {
                if (i === "FPS") {
                  return "#00b050";
                } else {
                  return "red";
                }
              }
              if (item < item2) {
                if (i === "FPS") {
                  return "red";
                } else {
                  return "#00b050";
                }
              }
            }
          }
        }
      }
    }
  }
  public com_num_color1(item, item2, type, i) {
    if (type) {
      if (typeof item == "number" && typeof item2 == "number") {
        if (i === "FPS") {
          if (this.get_core_data?.risk_rule != null) {
            let num = 0;
            if (this.get_core_data?.risk_rule.indexOf("%") != -1) {
              num = this.get_core_data?.risk_rule.replace("%", "");
              if (Math.abs(item - item2) > Number(num / 100)) {
                if (item > item2) {
                  return "#00b050";
                }
                if (item < item2) {
                  return "red";
                }
              }
            } else {
              if (Math.abs(item - item2) > this.get_core_data?.risk_rule) {
                if (item > item2) {
                  return "#00b050";
                }
                if (item < item2) {
                  return "red";
                }
              }
            }
          }
        } else {
          if (
            Math.abs(item - item2) / item2 >
            this.report_settings_threshold[type]
          ) {
            if (item > item2) {
              if (i === "FPS") {
                return "#00b050";
              } else {
                return "red";
              }
            }
            if (item < item2) {
              if (i === "FPS") {
                return "red";
              } else {
                return "#00b050";
              }
            }
          } else {
            return "#606266";
          }
        }
      } else {
        if (item === item2) {
          return "";
        }
      }
    }
  }
  public numList = [];
  public list = [];
  public b: any;
  public testShow = true;
  public htmlCanvas(item) {
    var getPixelRatio = (context) => {
      // 获取设备的PixelRatio
      var backingStore =
        context.backingStorePixelRatio ||
        context.webkitBackingStorePixelRatio ||
        context.mozBackingStorePixelRatio ||
        context.msBackingStorePixelRatio ||
        context.oBackingStorePixelRatio ||
        context.backingStorePixelRatio ||
        0.5;
      this.b = (this as any).$message({
        //Message 消息提示
        message: "报告发送中...",
        showClose: true,
        duration: 0,
      });
      return (window.devicePixelRatio || 0.5) / backingStore;
    };
    let shareContent: any = "";

    if (item === "func") {
      shareContent = document.getElementById("func");
    } else {
      // let b = window.frames["bdIframe"];
      // shareContent = b.document.getElementById("chart");
      // let b = window.frames["bdIframe"];
      shareContent = document.getElementById("chart");
      shareContent.style.fontSize = "12px";

      shareContent.style.whiteSpace = "nowrap";
      shareContent.style.textOverflow = "ellipsis";
      shareContent.style.overflow = "hidden";
      shareContent.style.fontFamily = "Verdana";
      shareContent.style.marginLeft = "4px";
      shareContent.style.marginRight = "4px";
      shareContent.style.lineHeight = "1.5";
    }

    // console.log(shareContent)
    var width = shareContent.offsetWidth;
    var height = shareContent.offsetHeight;
    var canvas = document.createElement("canvas");
    var context = canvas.getContext("2d");
    var scale = getPixelRatio(context); // 将canvas的容器扩大PixelRatio倍，再将画布缩放，将图像放大PixelRatio倍。
    canvas.width = width * scale;
    canvas.height = height * scale;
    canvas.style.width = width + "px";
    canvas.style.height = height + "px";
    context.scale(scale, scale);

    var opts = {
      scale: 1,
      canvas: canvas,
      dpi: window.devicePixelRatio,
      // 获取元素宽高 让其以一个规律或者固定宽高伸展
      width: (shareContent as any) + 400,
      height: (shareContent as any) + 500,
      // 将截图部分 移入中心位置
      scrollX: 200,
      scrollY: 250,
    };
    // 解决图片超出显示区后底色变成黑色的问题
    context.fillStyle = "#fff";

    context.fillRect(0, 0, canvas.width, canvas.height);
    var dataUrl = html2canvas(shareContent, opts).then(function (canvas) {
      context.imageSmoothingEnabled = false;
      (context as any).webkitImageSmoothingEnabled = false;
      (context as any).msImageSmoothingEnabled = false;
      context.imageSmoothingEnabled = false;
      return canvas.toDataURL("image/png", 1.0);
    });

    dataUrl.then((result) => {
      let res: any = {};
      res.file_base64 = result;
      res.filename = item + ".png";
      res.chinese = "frame_trend";

      this.resBase64.push(res);
      this.htmlCanvas1("func");
    });
  }
  public htmlCanvas1(item) {
    var getPixelRatio = function (context) {
      // 获取设备的PixelRatio
      var backingStore =
        context.backingStorePixelRatio ||
        context.webkitBackingStorePixelRatio ||
        context.mozBackingStorePixelRatio ||
        context.msBackingStorePixelRatio ||
        context.oBackingStorePixelRatio ||
        context.backingStorePixelRatio ||
        0.5;
      return (window.devicePixelRatio || 0.5) / backingStore;
    };
    let shareContent: any = "";
    if (item === "func") {
      shareContent = document.getElementById("func");
    } else {
      // let b = window.frames["bdIframe"];
      // shareContent = b.document.getElementById("chart");
      // let b = window.frames["bdIframe"];
      shareContent = document.getElementById("chart");
      shareContent.style.fontSize = "12px";

      shareContent.style.whiteSpace = "nowrap";
      shareContent.style.textOverflow = "ellipsis";
      shareContent.style.overflow = "hidden";
      shareContent.style.fontFamily = "Verdana";
      shareContent.style.marginLeft = "4px";
      shareContent.style.marginRight = "4px";
      shareContent.style.lineHeight = "1.5";
    }

    // console.log(shareContent)
    var width = shareContent.offsetWidth;
    var height = shareContent.offsetHeight;
    var canvas = document.createElement("canvas");
    var context = canvas.getContext("2d");
    var scale = getPixelRatio(context); // 将canvas的容器扩大PixelRatio倍，再将画布缩放，将图像放大PixelRatio倍。
    canvas.width = width * scale;
    canvas.height = height * scale;
    canvas.style.width = width + "px";
    canvas.style.height = height + "px";
    context.scale(scale, scale);

    var opts = {
      scale: 1,
      canvas: canvas,
      dpi: window.devicePixelRatio,
      // 获取元素宽高 让其以一个规律或者固定宽高伸展
      width: (shareContent as any) + 400,
      height: (shareContent as any) + 500,
      // 将截图部分 移入中心位置
      scrollX: 200,
      scrollY: 250,
    };
    // 解决图片超出显示区后底色变成黑色的问题
    context.fillStyle = "#fff";

    context.fillRect(0, 0, canvas.width, canvas.height);
    var dataUrl = html2canvas(shareContent, opts).then(function (canvas) {
      context.imageSmoothingEnabled = false;
      (context as any).webkitImageSmoothingEnabled = false;
      (context as any).msImageSmoothingEnabled = false;
      context.imageSmoothingEnabled = false;
      return canvas.toDataURL("image/png", 1.0);
    });

    dataUrl.then((result) => {
      let res: any = {};
      res.file_base64 = result;
      res.filename = item + ".png";
      res.chinese = "frame_trend";

      this.resBase64.push(res);

      this.target.forEach((v, index) => {
        this.drawTrends(v.value, index, v.title);
      });
      let upload_data: any;
      let old_test = this.versionsOldOptions.filter(
        (v) => v.chinese === this.dataConsumeOptions.old_verson
      )[0].id_test;
      this.edit = false;
      upload_data = {
        // project: Number(this.$route.query.project),
        project: this.localProject,
        id_test: Number(this.dataConsumeOptions.id_test),
        old_test: old_test,
        thread: this.dataConsumeOptions.thread,
        so: this.dataConsumeOptions.so,
        file_list: this.resBase64,
        title: this.formMail.title,
        recv: this.formMail.addressee,
        cc: this.formMail.CC_List,

        send: this.formMail.Sender,
      };

      dispatchUploadCpuReport(store, upload_data).then((res) => {
        if (res) {
          this.b.close();
        }
      });
    });
  }

  public com_num_color(item, item2, type, check) {
    if (type) {
      if (typeof item == "number" && typeof item2 == "number") {
        if (check == true) {
          if (
            Math.abs(item - item2) / item2 >
            this.report_settings_threshold[type]
          ) {
            if (item > item2) {
              return "red";
            }
            if (item < item2) {
              return "#00b050";
            }
          }
        } else {
          if (
            Math.abs(item - item2) >
            this.report_settings_threshold[type] * 100
          ) {
            if (item > item2) {
              return "red";
            }
            if (item < item2) {
              return "#00b050";
            }
          }
        }
      }
    }
  }
  public report_settings_threshold = {};
  public report_settings_threshold_abs = {};
  public text_list = {};
  public cpu_list = [];
  public thread_list = [];
  public getProjectName(i) {
    if (i == 12) {
      return "逆战手游";
    }
    if (i == 34) {
      return "王者荣耀海外";
    }
    if (i == 7) {
      return "QQ飞车手游";
    }
  }
  // public _le=10
  // public set le(value){
  //   console.log(`The value has changed from ${ this._le}${value}`);
  //   this._le=value
  // }
  public async mounted() {
    this.dataLoading = true;
    this.threadLoading = true;
    this.stackLoading = true;

    // this.le=20
    this.formMail.title = `【GR】${this.getProjectName(
      this.localProject
    )}自动化深度性能测试`;
    if (this.$route.query.id_test) {
      (this.dataConsumeOptions.id_test as any) = this.$route.query.id_test;
      let old_test = this.$route.query.old_test;
      (this.dataConsumeOptions.thread as any) = this.$route.query.thread;
      (this.dataConsumeOptions.so as any) = this.$route.query.so;

      await dispatchDeepPerformanceCpuCpuVersions(store, {
        project: this.localProject,
        is_auto: "",
        type: "",
        subtype: "",
      });
      await this.versionsOptions();

      this.dataConsumeOptions.version = this.version_list.filter(
        (v) => v.id_test == Number(this.dataConsumeOptions.id_test)
      )[0].chinese;
      let date = this.version_list.filter(
        (v) => v.chinese == this.dataConsumeOptions.version
      )[0].date;
      let version = this.version_list.filter(
        (v) => v.chinese == this.dataConsumeOptions.version
      )[0].game_version;
      this.dataConsumeOptions.id_test = this.version_list.filter(
        (v) => v.chinese == this.dataConsumeOptions.version
      )[0].id_test;
      let deivce_fil = this.version_list.filter(
        (v) => v.chinese == this.dataConsumeOptions.version
      )[0].device_id;
      let scene_fil = this.version_list.filter(
        (v) => v.chinese == this.dataConsumeOptions.version
      )[0].scene_id;
      await dispatchDeepPerformanceCpuDetail(store, {
        project: this.localProject,
        id_test: this.dataConsumeOptions.id_test,
      });
      dispatchDeepPerformanceFlameGraphUrl(store, {
        project: this.localProject,
        id_test: Number(this.dataConsumeOptions.id_test),
      });
      if (this.detail) {
        let report_settings = JSON.parse(readGetdeepCpuDetail(store).settings);
        this.report_settings_threshold = report_settings.threshold.change;
        this.report_settings_threshold_abs = report_settings.threshold.abs;
      }
      await dispatchGetDeepPerformanceSelectOptionsOld(store, {
        project: this.localProject,
        date: date,
        game_version: version,
      });

      this.dataConsumeOptions.device = deivce_fil;

      this.dataConsumeOptions.scene = scene_fil;
      await dispatchDeepPerformanceCpuCpuVersionsOld(store, {
        project: this.localProject,
        device_id: Number(this.dataConsumeOptions.device),
        scene_id: Number(this.dataConsumeOptions.scene),
        type: "",
        subtype: "",
        is_auto: "",
      });
      // this.dataConsumeOptions.old_verson =
      //   this.versionsOldOptions.length > 1
      //     ? this.versionsOldOptions[1].chinese
      //     : this.versionsOldOptions[0].chinese;
      this.dataConsumeOptions.old_verson = this.versionsOldOptions.filter(
        (v) => v.id_test == old_test
      )[0].chinese;
      await dispatchDeepPerformanceCpuCpuThreads(store, {
        project: this.localProject,

        id_test: this.dataConsumeOptions.id_test,
      }).then((res) => {
        this.dataConsumeOptions.thread = this.threadOptions[0];
        dispatchDeepPerformanceCpuCpuByFrame(store, {
          project: this.localProject,
          date: date,
          device_id: Number(this.dataConsumeOptions.device),
          scene_id: Number(this.dataConsumeOptions.scene),
          version: version,
          id_test: this.dataConsumeOptions.id_test,
          thread: this.dataConsumeOptions.thread,
        }).then((res) => {
          this.labels;

          this.series();
          this.$nextTick(() => {
            this.drawAnalyseTrend();
          });
          this.getFramesInfo(this.trendInex, this.trendInex);
          this.threadLoading = false;
          this.month = this.cpu_by_frame.frame_index[0];

          this.testShow = false;
          dispatchDeepPerformanceCpuStack(store, {
            project: this.localProject,
            id_test: Number(this.dataConsumeOptions.id_test),
            frame: this.cpu_by_frame.frame_index[0],

            thread: this.threadOptions,
          }).then((res) => {
            this.testShow = true;
            this.tableList = this.getTop10(this.stackData_obj).slice(1, 101);
            this.tableList.forEach((v) => {
              if (this.localProject == 34) {
                if (
                  v.name === "UnityMain" ||
                  v.name === "CoreThread" ||
                  v.name === "UnityGfx" ||
                  v.name === "NativeThread" ||
                  v.name === "Worker Thread"
                ) {
                  v.check = true;
                } else {
                  v.check = false;
                }
              } else {
                if (v.name === "GameThread" || v.name === "RenderThread") {
                  v.check = true;
                } else {
                  v.check = false;
                }
              }
            });
            this.tableList_new = this.tableList.slice(
              (this.currentPage - 1) * 10,
              this.currentPage * 10
            );
            this.total = this.tableList.length;

            (this.$refs.table as any).toggleRowExpansion(
              this.stackData_all[0],
              true
            );
            this.renderFlame("#chart", this.stackData_obj);
            // let c = (this.$refs.iframeDom as any).contentWindow;
            this.stackLoading = false;
            // setTimeout(() => {
            //   c.postMessage(
            //     {
            //       cmd: JSON.stringify(this.stackData_obj),
            //       apiUrl: 3,
            //       params: {},
            //     },
            //     "*"
            //   );
            // }, 200);
            // let iframe: any = document.getElementById("bdIframe");
            // window.addEventListener("message", (e) => {
            //   let data = e.data;

            //   iframe.height = Number(data.c) + 20 + "px";
            // });
          });
        });
        // .then((res) => {

        // });
        dispatchDeepPerformanceCpuFunctionCos(store, {
          project: this.localProject,
          thread: this.dataConsumeOptions.thread,
          id_test: this.dataConsumeOptions.id_test,
        }).then((res) => {
          dispatchDeepPerformanceCpuFuncReport(store, {
            project: this.localProject,
            id_test: Number(this.dataConsumeOptions.id_test),
            old_test: Number(old_test),
            thread: this.dataConsumeOptions.thread,
            so: this.dataConsumeOptions.so,
          }).then((res) => {
            this.get_data();
            //  数据分层
            let list = [];
            let indexList = [];
            this.get_core_data.func_list.data.forEach((v) => {
              if (v.type == "thread") {
                list.push(v.name);
              }
            });

            list.forEach((v) => {
              let index = this.get_core_data.func_list.data.findIndex(
                (k) => k.name === v
              );

              indexList.push(index);
            });

            for (let i = 0; i < indexList.length; i++) {
              this.text_list[list[i]] = this.get_core_data.func_list.data.slice(
                indexList[i] + 1,
                indexList[i + 1]
              );
            }

            for (let i in this.text_list) {
              let list = this.text_list[i].filter((v) => {
                return v.type !== "so";
              });
              this.text_list[i] = list;
            }

            for (let i in this.text_list) {
              if (this.findValue(i)[3] != true) {
                delete this.text_list[i];
              }
            }
            for (let i in this.text_list) {
              let list = this.text_list[i].filter((v) => {
                return this.findValue(v.name)[3] === true;
              });
              this.text_list[i] = list;
              let three = this.text_list[i].filter((v, index) => {
                return index <= 2;
              });
              this.text_list[i] = three;
            }
            // 分层结束
            // CPU数据分层
            // 获取8核
            let cpu_list_thead = this.params.slice(2, 10);
            let cpu_list = [];

            cpu_list_thead.forEach((v) => {
              cpu_list.push({
                name: v.name,
                new: this.get_core_data.cpu_usage_list[0].new[v.value]
                  ? this.get_core_data.cpu_usage_list[0].new[v.value]
                  : "",
                old: this.get_core_data.cpu_usage_list[0].old[v.value]
                  ? this.get_core_data.cpu_usage_list[0].old[v.value]
                  : "",
              });
            });

            this.cpu_list = cpu_list.filter(
              (v) => this.com_num_color5(v.new, "cpu", v.name) == "red"
            );
            // CPU数据结束
            // 线程数据
            this.thread_list = this.get_core_data.func_list.data.filter(
              (v) => v.type == "thread"
            );

            this.risk_description.push({
              device:
                this.get_core_data.basic.device_name +
                "-" +
                this.get_core_data.basic.device_level,
              scene: this.get_core_data.basic.scene,
              risk: "",
            });
            this.overList = Object.keys(this.get_core_data?.overview[0].new);
            this.target.forEach((v, index) => {
              this.$nextTick(() => {
                this.drawTrends(v.value, index, v.title);
              });
            });
            this.dataLoading = false;
          });
        });
      });
    } else {
      await dispatchDeepPerformanceCpuCpuVersions(store, {
        project: this.localProject,
        is_auto: "",
        type: "",
        subtype: "",
      });
      await this.versionsOptions();
      this.dataConsumeOptions.version = this.version_list[0]?.chinese;
      let date = this.version_list.filter(
        (v) => v.chinese == this.dataConsumeOptions.version
      )[0].date;
      let version = this.version_list.filter(
        (v) => v.chinese == this.dataConsumeOptions.version
      )[0].game_version;
      this.dataConsumeOptions.id_test = this.version_list.filter(
        (v) => v.chinese == this.dataConsumeOptions.version
      )[0].id_test;
      let deivce_fil = this.version_list.filter(
        (v) => v.chinese == this.dataConsumeOptions.version
      )[0].device_id;
      let scene_fil = this.version_list.filter(
        (v) => v.chinese == this.dataConsumeOptions.version
      )[0].scene_id;
      await dispatchDeepPerformanceCpuDetail(store, {
        project: this.localProject,
        id_test: this.dataConsumeOptions.id_test,
      });
      dispatchDeepPerformanceFlameGraphUrl(store, {
        project: this.localProject,
        id_test: Number(this.dataConsumeOptions.id_test),
      });
      if (this.detail) {
        let report_settings = JSON.parse(readGetdeepCpuDetail(store).settings);
        this.report_settings_threshold = report_settings.threshold.change;
        this.report_settings_threshold_abs = report_settings.threshold.abs;
      }
      await dispatchGetDeepPerformanceSelectOptionsOld(store, {
        project: this.localProject,
        date: date,
        game_version: version,
      });

      this.dataConsumeOptions.device = deivce_fil;

      this.dataConsumeOptions.scene = scene_fil;
      await dispatchDeepPerformanceCpuCpuVersionsOld(store, {
        project: this.localProject,
        device_id: Number(this.dataConsumeOptions.device),
        scene_id: Number(this.dataConsumeOptions.scene),
        type: "",
        subtype: "",
        is_auto: "",
      });
      this.dataConsumeOptions.old_verson =
        this.versionsOldOptions.length > 1
          ? this.versionsOldOptions[1].chinese
          : this.versionsOldOptions[0].chinese;
      let old_test = this.versionsOldOptions.filter(
        (v) => v.chinese === this.dataConsumeOptions.old_verson
      )[0].id_test;
      await dispatchDeepPerformanceCpuCpuThreads(store, {
        project: this.localProject,

        id_test: this.dataConsumeOptions.id_test,
      }).then((res) => {
        this.dataConsumeOptions.thread = this.threadOptions[0];
        dispatchDeepPerformanceCpuCpuByFrame(store, {
          project: this.localProject,
          date: date,
          device_id: Number(this.dataConsumeOptions.device),
          scene_id: Number(this.dataConsumeOptions.scene),
          version: version,
          id_test: this.dataConsumeOptions.id_test,
          thread: this.dataConsumeOptions.thread,
        })
          .then((res) => {
            this.labels;
            this.series();
            this.$nextTick(() => {
              this.drawAnalyseTrend();
            });
            this.threadLoading = false;
            this.month = this.cpu_by_frame.frame_index[0];

            this.testShow = false;
            dispatchDeepPerformanceCpuStack(store, {
              project: this.localProject,
              id_test: Number(this.dataConsumeOptions.id_test),
              frame: 0,

              thread: this.threadOptions,
            }).then((res) => {
              this.testShow = true;
              this.tableList = this.getTop10(this.stackData_obj).slice(1, 101);
              this.tableList.forEach((v) => {
                if (this.localProject == 34) {
                  if (
                    v.name === "UnityMain" ||
                    v.name === "CoreThread" ||
                    v.name === "UnityGfx" ||
                    v.name === "NativeThread" ||
                    v.name === "Worker Thread"
                  ) {
                    v.check = true;
                  } else {
                    v.check = false;
                  }
                } else {
                  if (v.name === "GameThread" || v.name === "RenderThread") {
                    v.check = true;
                  } else {
                    v.check = false;
                  }
                }
              });
              this.tableList_new = this.tableList.slice(
                (this.currentPage - 1) * 10,
                this.currentPage * 10
              );
              this.total = this.tableList.length;
              (this.$refs.table as any).toggleRowExpansion(
                this.stackData_all[0],
                true
              );
              this.renderFlame("#chart", this.stackData_obj);
              // let c = (this.$refs.iframeDom as any).contentWindow;

              // setTimeout(() => {
              //   c.postMessage(
              //     {
              //       cmd: JSON.stringify(this.stackData_obj),
              //       apiUrl: 3,
              //       params: {},
              //     },
              //     "*"
              //   );
              // }, 200);
              // let iframe: any = document.getElementById("bdIframe");
              // window.addEventListener("message", (e) => {
              //   let data = e.data;

              //   iframe.height = Number(data.c) + 20 + "px";
              // });
            });
          })
          .then((res) => {
            this.stackLoading = false;
          });
        dispatchDeepPerformanceCpuFunctionCos(store, {
          project: this.localProject,
          thread: this.dataConsumeOptions.thread,
          id_test: this.dataConsumeOptions.id_test,
        }).then((res) => {
          this.dataConsumeOptions.so = this.cpu_function_cos[0];
          dispatchDeepPerformanceCpuFuncReport(store, {
            project: this.localProject,
            id_test: Number(this.dataConsumeOptions.id_test),
            old_test: old_test,
            thread: this.dataConsumeOptions.thread,
            so: this.dataConsumeOptions.so,
          }).then((res) => {
            this.get_data();
            //  数据分层
            let list = [];
            let indexList = [];
            this.get_core_data.func_list.data.forEach((v) => {
              if (v.type == "thread") {
                list.push(v.name);
              }
            });

            list.forEach((v) => {
              let index = this.get_core_data.func_list.data.findIndex(
                (k) => k.name === v
              );

              indexList.push(index);
            });

            for (let i = 0; i < indexList.length; i++) {
              this.text_list[list[i]] = this.get_core_data.func_list.data.slice(
                indexList[i] + 1,
                indexList[i + 1]
              );
            }

            for (let i in this.text_list) {
              let list = this.text_list[i].filter((v) => {
                return v.type !== "so";
              });
              this.text_list[i] = list;
            }

            for (let i in this.text_list) {
              if (this.findValue(i)[3] != true) {
                delete this.text_list[i];
              }
              // let list=this.text_list[i].filter(v=>{
              //   return this.findValue(v.name)[3]===true

              // })
              // this.text_list[i]=list
              // let three=this.text_list[i].filter((v,index)=>{
              //  return  index<=2
              // })
              // this.text_list[i]=three
            }
            for (let i in this.text_list) {
              let list = this.text_list[i].filter((v) => {
                return this.findValue(v.name)[3] === true;
              });
              this.text_list[i] = list;
              let three = this.text_list[i].filter((v, index) => {
                return index <= 2;
              });
              this.text_list[i] = three;
            }
            // 分层结束
            // 获取8核
            let cpu_list_thead = this.params.slice(2, 10);
            let cpu_list = [];

            cpu_list_thead.forEach((v) => {
              cpu_list.push({
                name: v.name,
                new: this.get_core_data.cpu_usage_list[0].new[v.value]
                  ? this.get_core_data.cpu_usage_list[0].new[v.value]
                  : "",
                old: this.get_core_data.cpu_usage_list[0].old[v.value]
                  ? this.get_core_data.cpu_usage_list[0].old[v.value]
                  : "",
              });
            });

            this.cpu_list = cpu_list.filter(
              (v) => this.com_num_color5(v.new, "cpu", v.name) == "red"
            );
            // CPU数据结束
            // 线程数据
            this.thread_list = this.get_core_data.func_list.data.filter(
              (v) => v.type == "thread"
            );
            this.risk_description.push({
              device:
                this.get_core_data.basic.device_name +
                "-" +
                this.get_core_data.basic.device_level,
              scene: this.get_core_data.basic.scene,
              risk: "",
            });
            this.overList = Object.keys(this.get_core_data?.overview[0].new);
            this.target.forEach((v, index) => {
              this.$nextTick(() => {
                this.drawTrends(v.value, index, v.title);
              });
            });
            this.dataLoading = false;
          });
          this.$router.push({
            query: {
              ...this.$route.query,
              id_test: this.dataConsumeOptions.id_test,
              old_test: old_test,
              thread: this.dataConsumeOptions.thread,

              so: this.dataConsumeOptions.so,
            },
          });
        });
      });
    }
  }
  public abc(item) {
    let list = ["a", "b", "c"];
    return list[item];
  }

  public findValue(item) {
    let newValue = this.get_core_data.func_list.data.filter(
      (v) => v.name == item
    )[0].list[0].event_count;
    let oldValue = this.get_core_data.func_list.data.filter(
      (v) => v.name == item
    )[0].list[0].old_event_count;
    let type = this.get_core_data.func_list.data.filter(
      (v) => v.name == item
    )[0].type;
    let old = this.getNum(newValue, oldValue);
    let color = this.com_num_color(newValue, oldValue, type, true);
    let check = false;
    if (color == "red") {
      check = true;
    }
    return [newValue, old, color, check];
  }
  public get flame_url() {
    return readGetdeepFlameUrl(store);
  }
  public getTop10(data) {
    const result = [];
    if (data.value) {
      result.push({
        name: data.name,
        time: data.value,
        rate: data.rate,
        id: data.id,
      });
    }
    if (data.children && data.children.length > 0) {
      data.children.forEach((item) => {
        result.push(...this.getTop10(item));
      });
    }
    result.sort((a, b) => b.time - a.time);
    return result.slice(0, 101);
  }
  public drawTrends(item, i, v) {
    let series = [];
    let xData = [];
    let yaxis: any = [] || {};
    if (item === "cpu_usage_trend") {
      this.get_core_data[item].chinese.forEach((v, index) => {
        series.push({
          name: v,
          type: "line",
          data: this.get_core_data[item].series[index],
          smooth: true, // 平滑曲线
          symbol: "circle", //拐点设置为实心,

          itemStyle: {
            normal: {
              label: {
                // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
                show: true,
              },
            },
          },

          yAxisIndex: v === "Freq MHz" ? 1 : 0,
        });

        xData = this.get_core_data[item].date_list;
        yaxis = [
          {
            name: "",
            type: "value",
          },
          {
            type: "value",
            splitLine: {
              show: false,
            },
          },
        ];
      });
    }
    if (item === "thread_trend" || item == "module_trend") {
      this.get_core_data[item].chinese.forEach((v, index) => {
        series.push({
          name: v,
          type: "line",
          data: this.get_core_data[item].series[index],
          smooth: true, // 平滑曲线
          symbol: "circle", //拐点设置为实心
          itemStyle: {
            normal: {
              label: {
                // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
                show: true,
              },
            },
          },
        });
        xData = this.get_core_data[item].date_list;
        yaxis = {
          type: "value",
        };
      });
    }
    let performance_line: any = document.getElementById(item);
    echarts.dispose(performance_line);
    let PerformanceLineChart = echarts.init(performance_line);
    let option;
    option = {
      title: {
        left: "center",
        textStyle: {
          fontSize: 16,
          fontWeight: "normal",
        },
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "20%",
        right: "4%",
        containLabel: true,
      },

      animation: false,
      xAxis: {
        type: "category",
        data: xData,
      },
      yAxis: yaxis,
      series: series,
    };

    PerformanceLineChart.setOption(option);
    //                PerformanceLineChart.dispatchAction({
    //     type: "showTip",
    //     seriesIndex: 0,
    //     dataIndex: 0
    // })

    var res_base64 = PerformanceLineChart.getDataURL({
      excludeComponents: ["toolbox"],
    }); //拿到base64 地址，就好下载了。
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = String(i) + "-" + ".png";
    res.chinese =
      v +
      "-" +
      this.get_core_data.basic.device_name +
      "-" +
      this.get_core_data.basic.scene;
    this.resBase64.push(res);
  }
  public get target() {
    return [
      { title: "CPU Usage趋势", value: "cpu_usage_trend" },
      { title: "线程耗时趋势", value: "thread_trend" },
      { title: "模块耗时趋势", value: "module_trend" },
    ];
  }

  public series_list = [];
  public series() {
    this.series_list = [];
    let list = Object.keys(this.cpu_by_frame?.thread_list);

    list.forEach((v, index) => {
      this.series_list.push({
        name: v,
        type: "line",

        showSymbol: false,

        itemStyle: {
          normal: {
            lineStyle: {
              width: 1,
            },
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
        yAxisIndex: 0,
        id: this.cpu_by_frame?.thread_list[v],
        data: this.cpu_by_frame?.series[index],
      });
    });

    return this.series_list;
  }
  public get series_creat() {
    let list = [];
    this.cpu_by_frame?.thread_list.forEach((v, index) => {
      if (this.localProject === 34) {
        if (
          v === "FrameTime" ||
          v === "UnityMain" ||
          v === "CoreThread" ||
          v === "UnityGfx" ||
          v === "NativeThread" ||
          v === "Worker Thread"
        ) {
          list.push({
            name: v,
            type: "line",

            showSymbol: false,

            itemStyle: {
              normal: {
                lineStyle: {
                  width: 1,
                },
              },
              emphasis: {
                lineStyle: {
                  width: 1, // hover时的折线宽度
                },
              },
            },
            yAxisIndex: 0,
            data: this.cpu_by_frame?.series[index],
          });
        }
      } else {
        if (v === "FrameTime" || v === "GameThread" || v === "RenderThread") {
          list.push({
            name: v,
            type: "line",

            showSymbol: false,

            itemStyle: {
              normal: {
                lineStyle: {
                  width: 1,
                },
              },
              emphasis: {
                lineStyle: {
                  width: 1, // hover时的折线宽度
                },
              },
            },
            yAxisIndex: 0,
            data: this.cpu_by_frame?.series[index],
          });
        }
      }
    });
    return list;
  }
  public list1 = [];
  public get cpu_by_frame() {
    // readGetdeepCpuByFrame(store).series[0]=readGetdeepCpuByFrame(store).series[1]
    return readGetdeepCpuByFrame(store);
  }
  public get ratelist() {
    return readGetdeepTrendNode(store);
  }
  public async checkChange(item, id, name) {
    await dispatchDeepPerformanceTrendNode(store, {
      project: this.localProject,
      id_test: this.dataConsumeOptions.id_test,
      node_id: id,
    });
    if (item) {
      this.series_list.push({
        name: name,
        type: "line",
        id: id,
        showSymbol: false,

        itemStyle: {
          normal: {
            lineStyle: {
              width: 1,
            },
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
        yAxisIndex: 0,
        data: this.ratelist.map((item) => (item === null ? 0 : item)),
      });
    } else {
      let target_index = this.series_list.findIndex((v) => v.name == name);
      this.series_list.splice(target_index, 1);
    }
    this.selectData();
    this.drawAnalyseTrend();
  }
  public abs_time = 0;
  public month = 0;
  public trendInex = 0;
  public async drawAnalyseTrend() {
    let performance_line: any = document.getElementById("analyse");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    let series = [];
    let xAxis = [];
    for (let i = 0; i < this.cpu_by_frame?.frame_index.length; i++) {
      xAxis.push(i);
    }

    // this.cpu_by_frame?.thread_list.forEach((v, index) => {
    //   series.push({
    //     name: v,
    //     type: "line",

    //     showSymbol: false,

    //     itemStyle: {
    //       normal: {
    //         lineStyle: {
    //           width: 1,
    //         },
    //       },
    //       emphasis: {
    //         lineStyle: {
    //           width: 1, // hover时的折线宽度
    //         },
    //       },
    //     },
    //     data: this.cpu_by_frame?.series[index],
    //   });
    // });

    if (this.makLineShow) {
      this.series_list[0].markLine = {
        symbol: ["circle", "arrow"],
        data: [
          {
            silent: false,
            xAxis: this.trendInex,
            label: {
              position: "end",
              formatter: this.trendInex,
              show: this.makLineShow,
              color: "ED5664",
            },
            lineStyle: {
              type: "solid",
              color: "#ED5664",
              width: "1",
            },
          },
        ],
      };
    } else {
      this.series_list[0].markLine = {
        data: [],
        label: {
          show: this.makLineShow,
        },
      };
    }

    contrastChart.on("datazoom", (params: any) => {
      // let timeIndexStart =
      //   this.cpu_by_frame.frame_index.length * (params.start / 100);
      // let timeIndexEnd =
      //   this.cpu_by_frame.frame_index.length * (params.end / 100);
      // let arr = this.cpu_by_frame.frame_index.filter((v, i) => {
      //   if (
      //     Math.round(timeIndexStart) === this.cpu_by_frame.frame_index.length
      //   ) {
      //     return (
      //       i >= Math.round(timeIndexStart) - 1 && i < Math.round(timeIndexEnd)
      //     );
      //   } else {
      //     return (
      //       i >= Math.round(timeIndexStart) && i <= Math.round(timeIndexEnd)
      //     );
      //   }
      // });
      // let newLabelName = this.cpu_by_frame_list.flat().filter((v, i) => {
      //   if (
      //     Math.round(timeIndexStart) === this.cpu_by_frame.frame_index.length
      //   ) {
      //     return (
      //       i >= Math.round(timeIndexStart) - 1 && i < Math.round(timeIndexEnd)
      //     );
      //   } else {
      //     return (
      //       i >= Math.round(timeIndexStart) && i <= Math.round(timeIndexEnd)
      //     );
      //   }
      // });
      let xAxis = (contrastChart as any).getModel().option; // 获取x轴数据 我这个是时间
      let series = (contrastChart as any).getModel().option.series[0]; // 获取数据
      let start_rate = params.start;
      let end_rate = params.end;
      this.startValue = start_rate;
      this.endValue = end_rate;
      // console.log(series); // 这个是获取的数据
      //           console.log(series.data);
      //            console.log(xAxis.rangeStart);//滑动条左端对应在xAxis.data的索引
      //           console.log(xAxis.rangeEnd);//滑动条右端对应在xAxis.data的索引
      let timeIndexStart =
        this.cpu_by_frame.frame_index.length * (params.start / 100);
      let timeIndexEnd =
        this.cpu_by_frame.frame_index.length * (params.end / 100);
      let start = (contrastChart as any).getModel().option.dataZoom[0]
        .startValue;
      let end = (contrastChart as any).getModel().option.dataZoom[0].endValue;
      let arr = this.cpu_by_frame.frame_index.filter((v, i) => {
        if (start === this.cpu_by_frame.frame_index.length) {
          return i >= start - 1 && i < end;
        } else {
          return i >= start && i <= end;
        }
      });
      let newLabelName = this.cpu_by_frame_list.flat().filter((v, i) => {
        if (start === this.cpu_by_frame.frame_index.length) {
          return i >= start - 1 && i < end;
        } else {
          return i >= start && i <= end;
        }
      });
      var newArr = [],
        tempArr = [];
      for (var i = 0, j = newLabelName.length; i < j; i++) {
        if (newLabelName[i] == newLabelName[i + 1]) {
          tempArr.push(newLabelName[i]);
        } else {
          tempArr.push(newLabelName[i]);
          newArr.push(tempArr.slice(0));
          tempArr.length = 0;
        }
      }

      let c = newArr.flat();
      let n = Array.from(new Set(c));
      let nameArr = [];
      let name1Arr = [];
      this.labels.forEach((v) => {
        n.forEach((j) => {
          if (v.label === j) {
            nameArr.push(v);
          }
        });
      });

      newArr.forEach((v) => {
        name1Arr.push({
          label: v[0],
          width: (v.length / arr.length) * 100 + "%",
        });
      });

      nameArr.forEach((v) => {
        name1Arr.forEach((j) => {
          if (v.label == j.label) {
            v.width = j.width;
          }
        });
      });
      this.list = nameArr;
    });
    contrastChart.on("brushEnd", (params: any) => {
      let list = [];

      if (params.areas.length > 0) {
        this.stackLoading = true;
        let start = params.areas[0]?.coordRange[0];
        let end = params.areas[0]?.coordRange[1];
        this.coordRange = [start, end];
        this.selectShow = true;

        for (
          let i = params.areas[0].coordRange[0];
          i <= params.areas[0].coordRange[1];
          i++
        ) {
          list.push(i);
        }
        this.getFramesInfo(
          params.areas[0].coordRange[0],
          params.areas[0].coordRange[1]
        );
        let all_list = [];
        // list.forEach((v) => {
        //   let i = [];
        //   i.push(this.cpu_by_frame?.frame_index[v]);
        //   i.push(this.cpu_by_frame?.abs_time[v]);
        //   all_list.push(i);
        // });
        // contrastChart.setOption({
        //    title: {
        //       backgroundColor: '#333',
        //       	text: '铁损平均值:',

        //       	left: params.batch[0].areas[0].range[1],
        //       	textStyle: {
        //         	fontSize: 14,
        //         	color: '#fff',
        //         	fontWeight:'normal'
        //       	}
        //     }
        //   });
        this.testShow = false;
        this.makLineShow = false;
        this.series_list[0].markLine = {
          data: [],
          label: {
            show: this.makLineShow,
          },
        };

        this.selectData();
        this.drawAnalyseTrend();
        dispatchDeepPerformanceCpuStackMerge(store, {
          project: this.localProject,
          id_test: Number(this.dataConsumeOptions.id_test),
          frames: list,
          threads: this.threadOptions,
        }).then((res) => {
          this.testShow = true;
          this.tableList = this.getTop10(this.stackData_obj).slice(1, 101);
          this.currentPage = 1;
          this.tableList_new = this.tableList.slice(
            (this.currentPage - 1) * 10,
            this.currentPage * 10
          );
          this.total = this.tableList.length;
          this.serch = "";

          this.tableList.forEach((v) => {
            let found = false;
            this.series_list.forEach((item) => {
              if (v.name == item.name) {
                v.check = true;
                found = true;
                return false; // 跳出循环
              }
              if (!found) {
                v.check = false;
              }
            });
          });
          (this.$refs.table as any).toggleRowExpansion(
            this.stackData_all[0],
            true
          );
          this.renderFlame("#chart", this.stackData_obj);
          this.stackLoading = false;
        });
      }

      // contrastChart.setOption({
      //   title: {
      //     backgroundColor: "#333",
      //     text: "SELECTED DATA INDICES: \n",
      //     bottom: 200,
      //     right: "0%",
      //     width: 100,
      //     textStyle: {
      //       fontSize: 12,
      //       color: "#fff",
      //     },
      //   },
      // });
    });

    contrastChart.getZr().on("click", (params) => {
      var pointInPixel = [params.offsetX, params.offsetY];
      this.coordRange = [];
      this.selectShow = false;
      if (contrastChart.containPixel("grid", pointInPixel)) {
        /*此处添加具体执行代码*/
        this.stackLoading = true;
        var pointInGrid = contrastChart.convertFromPixel(
          { seriesIndex: 0 },
          pointInPixel
        );
        //X轴序号
        var xIndex = pointInGrid[0];
        var rangeY = (contrastChart as any).getModel().getComponent("yAxis")
          .axis.scale._extent;

        //获取当前图表的option
        var op = contrastChart.getOption();

        //获得图表中我们想要的数据

        var month = op.xAxis[0].data[xIndex];
        this.trendInex = month;
        var value = op.series[0].data[xIndex];

        // this.month = this.cpu_by_frame?.frame_index[xIndex];

        this.getFramesInfo(month, month);
        // dispatchDeepPerformanceCpuStackCreated(store, {
        //   project: this.localProject,
        //   id_test: Number(readGetdeepCpuByFrame(store).id_test),
        //   frame: this.abs_time,
        //   depth:0,
        //   id_row:'',
        // thread:this.lastThread,
        //  abs_time: this.month
        // })
        this.makLineShow = true;
        this.series_list[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: false,
              xAxis: month,
              label: {
                position: "end",
                formatter: month,
                show: this.makLineShow,
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
              },
            },
          ],
        };

        contrastChart.setOption({
          series: this.series_list,
        });
        // this.series_list = [...this.series_creat];
        this.drawAnalyseTrend();
        this.testShow = false;
        dispatchDeepPerformanceCpuStack(store, {
          project: this.localProject,
          id_test: Number(this.dataConsumeOptions.id_test),
          frame: this.month,
          thread: this.threadOptions,
        }).then((res) => {
          this.testShow = true;
          this.tableList = this.getTop10(this.stackData_obj).slice(1, 101);
          this.currentPage = 1;

          this.total = this.tableList.length;
          this.serch = "";

          //  this.tableList.forEach((v) => {
          //     if (this.localProject == 34) {
          //       if (
          //         v.name === "UnityMain" ||
          //         v.name === "CoreThread" ||
          //         v.name === "UnityGfx" ||
          //         v.name === "NativeThread" ||
          //         v.name === "Worker Thread"
          //       ) {
          //         v.check = true;
          //       } else {
          //         v.check = false;
          //       }
          //     } else {
          //       if (v.name === "GameThread" || v.name === "RenderThread"||v.name === "UWorld::Tick") {
          //         v.check = true;
          //       } else {
          //         v.check = false;
          //       }
          //     }
          //   });
          this.tableList.forEach((v) => {
            let found = false;
            this.series_list.forEach((item) => {
              if (v.name == item.name) {
                v.check = true;
                found = true;
                return false; // 跳出循环
              }
              if (!found) {
                v.check = false;
              }
            });
          });

          this.tableList_new = this.tableList.slice(
            (this.currentPage - 1) * 10,
            this.currentPage * 10
          );

          (this.$refs.table as any).toggleRowExpansion(
            this.stackData_all[0],
            true
          );
          this.renderFlame("#chart", this.stackData_obj);

          // let c = (this.$refs.iframeDom as any).contentWindow;

          // setTimeout(() => {
          //   c.postMessage(
          //     {
          //       cmd: JSON.stringify(this.stackData_obj),
          //       apiUrl: 3,
          //       params: {},
          //     },
          //     "*"
          //   );
          // }, 200);
          // let iframe: any = document.getElementById("bdIframe");
          // window.addEventListener("message", (e) => {
          //   let data = e.data;

          //   iframe.height = Number(data.c) + 20 + "px";
          // });

          this.stackLoading = false;
        });
        //
        //
      }

      // function sibling(elm) {
      //   var a = [];
      //   var p = elm.parentNode.children;
      //   for (var i = 0, pl = p.length; i < pl; i++) {
      //     if (p[i] !== elm) a.push(p[i]);
      //   }
      //   return a;
      // }
      //      series[0].markLine={
      //    data: [
      // 		[
      // 			{
      // 				name:'时间轴:'+month,
      // 				itemStyle:{
      // 					normal:{
      // 						show:true,
      // 						color:'#ED5664'
      // 					}
      // 				},
      // 				coord:[month,0]
      // 			},
      // 			{
      //      coord:[month,rangeY[1]]
      // 				},

      // 		],
      // 	  ]
      // }
    });
    //   window.addEventListener("resize", () => {
    //   contrastChart.resize();
    // });
    contrastChart.dispatchAction({
      // 刷选模式的开关。使用此 action 可将当前鼠标变为可刷选状态。 事实上，点击 toolbox 中的 brush 按钮时，就是通过这个 action，将当前普通鼠标变为刷选器的。
      type: "takeGlobalCursor",
      // 如果想变为“可刷选状态”，必须设置。不设置则会关闭“可刷选状态”。
      key: "brush",
      brushOption: {
        // 参见 brush 组件的 brushType。如果设置为 false 则关闭“可刷选状态”。
        brushType: "lineX",
        // 参见 brush 组件的 brushMode。如果不设置，则取 brush 组件的 brushMode 设置。
        brushMode: "single",
      },
    });
    contrastChart.setOption({
      title: {
        text: "",
        textStyle: {
          fontSize: 16,
          fontWeight: 700,
          color: "#333",
        },
      },
      yAxis: {
        type: "value",
      },
      series: this.series_list,
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: xAxis,
      },
      dataZoom: [
        //给x轴设置滚动条
        {
          start: this.startValue,
          end: this.endValue,
          // end: 100 - 1500 / 31, //默认为100
          type: "slider",
          show: true,
          xAxisIndex: [0],
          // handleSize: 0, //滑动条的 左右2个滑动条的大小
          height: 14, //组件高度
          left: 50, //左边的距离
          right: 40, //右边的距离
          bottom: 40, //右边的距离
          handleColor: "#ddd", //h滑动图标的颜色
          handleStyle: {
            borderColor: "#cacaca",
            borderWidth: "1",
            shadowBlur: 2,
            background: "#ddd",
            shadowColor: "#ddd",
          },
          fillerColor: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
            {
              //给颜色设置渐变色 前面4个参数，给第一个设置1，第四个设置0 ，就是水平渐变
              //给第一个设置0，第四个设置1，就是垂直渐变
              offset: 0,
              color: "#1eb5e5",
            },
            {
              offset: 1,
              color: "#5ccbb1",
            },
          ]),
          backgroundColor: "#ddd", //两边未选中的滑动条区域的颜色
          showDataShadow: false, //是否显示数据阴影 默认auto
          showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
          handleIcon:
            "M-292,322.2c-3.2,0-6.4-0.6-9.3-1.9c-2.9-1.2-5.4-2.9-7.6-5.1s-3.9-4.8-5.1-7.6c-1.3-3-1.9-6.1-1.9-9.3c0-3.2,0.6-6.4,1.9-9.3c1.2-2.9,2.9-5.4,5.1-7.6s4.8-3.9,7.6-5.1c3-1.3,6.1-1.9,9.3-1.9c3.2,0,6.4,0.6,9.3,1.9c2.9,1.2,5.4,2.9,7.6,5.1s3.9,4.8,5.1,7.6c1.3,3,1.9,6.1,1.9,9.3c0,3.2-0.6,6.4-1.9,9.3c-1.2,2.9-2.9,5.4-5.1,7.6s-4.8,3.9-7.6,5.1C-285.6,321.5-288.8,322.2-292,322.2z",
          filterMode: "filter",
        },
        //下面这个属性是里面拖到
        {
          type: "inside",
          show: true,
          xAxisIndex: [0],
          disabled: true, // 禁用鼠标滚动缩放
          //  start: 0,//默认为1
          //  end: 100-1500/31,//默认为100
        },
      ],
      toolbox: {
        feature: {
          saveAsImage: {},
        },
        top: 20,
      },
      brush: {
        toolbox: ["lineX"],
        brushType: "lineX",
        transformable: false,
        xAxisIndex: 0,
        // brushMode: "multiple",
        // throttleType: "debounce", //开启选中延迟后调用回调延迟
        // throttleDelay: 1000, //选中延迟后调用回调延迟时间
      },
      tooltip: {
        trigger: "axis",
        confine: true,
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: "line", // 默认为直线，可选为：'line' | 'shadow'
        },
        formatter: (params) => {
          {
            //  只粘贴formatter了

            let relVal =
              Number(params[0].axisValueLabel) * this.frame_merge_size +
              "-" +
              (Number(params[0].axisValueLabel) + 1) * this.frame_merge_size;
            for (let i = 0; i < params.length; i++) {
              relVal +=
                "<div  style='display:flex;align-items:center;' ><div style='width:120px'>" +
                params[i].marker +
                params[i].seriesName +
                '</div><div style="font-weight:bold">' +
                (params[i].value == undefined ? "-" : params[i].value) + //   不同点
                "</div></div>";
            }

            return relVal;
          }
        },
        extraCssText: "white-space: normal; word-break: break-all;",

        //  formatter: function (params) {
        //   if (params instanceof Array) {
        //     let str = '';
        //     str += `${params[0].axisValue}<br/>`;
        //     params.forEach((m, index) => {

        //       str +=  `<span class="chart-tooltip-color" style="display: inline-block; margin-right: 10px; background-color: ${m.color}; width: 10px; height: 10px; border-radius:100%; margin-right: 5px"></span>`;
        //       str += `${m.seriesName}：${m.data==null?'--':m.data}`;
        //       str += `${index % 4 === 0 ? '<br/>' : ''}`; //一排放几个可根据实际情况改变
        //     });
        //     return str;
        //   }
        // },
      },
      legend: {
        type: "scroll",
        y: "bottom",
      },
      grid: {
        left: "8%",
        right: "4%",
        bottom: "25%",
        top: "20%",
        // containLabel: true,
      },
      animation: false,
      itemStyle: {
        normal: {
          color: "#3ba272",
          lineStyle: {
            width: 1, // 正常时的折线宽度
          },
        },
        emphasis: {
          lineStyle: {
            width: 1, // hover时的折线宽度
          },
        },
      },
      itemStyle2: {
        normal: {
          lineStyle: {
            width: 1,
          },
        },
        emphasis: {
          lineStyle: {
            width: 1, // hover时的折线宽度
          },
        },
      },
    });
    contrastChart.dispatchAction({
      type: "brush",
      areas: [
        {
          brushType: "lineX",
          coordRange: this.coordRange,
          xAxisIndex: 0,
        },
      ],
    });
    contrastChart.dispatchAction({
      // 刷选模式的开关。使用此 action 可将当前鼠标变为可刷选状态。 事实上，点击 toolbox 中的 brush 按钮时，就是通过这个 action，将当前普通鼠标变为刷选器的。
      type: "takeGlobalCursor",
      // 如果想变为“可刷选状态”，必须设置。不设置则会关闭“可刷选状态”。
      key: "brush",
      brushOption: {
        // 参见 brush 组件的 brushType。如果设置为 false 则关闭“可刷选状态”。
        brushType: "lineX",
        // 参见 brush 组件的 brushMode。如果不设置，则取 brush 组件的 brushMode 设置。
        brushMode: "single",
      },
    });
  }
  public labelTime = (d) => {
    return (
      d.data.name +
      "(" +
      (d.parent == null
        ? "100%"
        : ((d.value / (this.stackData_obj as any).value) * 100).toFixed(2) +
          "%") +
      "," +
      d.value +
      "ms" +
      ")"
    );
  };
  public dataUrl = "";
  // public test(){
  //      let shareContent: any
  //    let b = window.frames["bdIframe"];
  //     shareContent = b.document.getElementById("chart");
  //     shareContent.style.fontSize='12px'
  //     shareContent.style.fontSize='12px'
  //     domtoimage.toPng(shareContent)
  //               .then((dataUrl) => {
  //                   //console.log(dataUrl)
  //                   console.log(dataUrl)
  //                   this.dataUrl=dataUrl
  //               })
  //               .catch(function (error) {
  //                   console.error('生成失败', error);
  //               });

  //       }

  public get labels() {
    this.list = [];
    let num = 0;
    this.cpu_by_frame?.labels.forEach((v) => {
      num += v.length;
    });
    this.cpu_by_frame?.labels.forEach((v, index) => {
      this.list.push({
        label: v[0] + "_" + index,
        width: (v.length / num) * 100 + "%",
        color: this.allColorList[index],
      });
    });

    return this.list;
  }
  public get allColorList() {
    let list = [];
    for (let i = 0; i < 3; i++) {
      this.colList.forEach((v) => {
        list.push(v);
      });
    }
    return list;
  }
  public colList = [
    "rgba(237, 86, 100)",
    "rgba(145, 124, 190)",
    "rgba(94, 190, 181)",
    "rgba(237, 131, 92)",
    "rgba(102, 132, 213)",
    "rgba(250, 203, 97)",
    "rgba(59, 162, 114)",
    "rgba(102, 132, 213)",
    "rgba(53, 166, 159)",
    "rgba(250, 203, 97)",
    "rgba(237, 86, 100)",
    "rgba(145, 124, 190)",
    "rgba(94, 190, 181)",
    "rgba(237, 131, 92)",
    "rgba(102, 132, 213)",
    "rgba(250, 203, 97)",
    "rgba(59, 162, 114)",
    "rgba(102, 132, 213)",
    "rgba(53, 166, 159)",
    "rgba(250, 203, 97)",
  ];
  public startValue = 0;
  public endValue = 100;
  public coordRange = [];
  public selectShow = false;
  public selectList = [];
  public selectStart = 0;
  public selectEnd = 0;
  public func_name = "";
  public func_rate = "";
  public flame_serch = "";
  public frame_merge_size = 10;
  public tableList_new = [];
  public serch = "";
  public currentPage = 1;
  public total = 1;
  public tableList = [];
  public makLineShow = true;
  public framesInfo = {
    framesCount: 0,
    start: 0,
    end: 0,
    sumTime: 0,
    FPS: 0,

    ratelist: [],
    frameTime: 0,
  };

  public trendIndex = 0;
  public selectData() {
    let list = [];
    this.selectList = [];
    if (this.coordRange.length > 0) {
      this.selectStart = this.coordRange[0];
      this.selectEnd = this.coordRange[1];
    }

    this.series_list.forEach((v) => {
      //   let num=0
      //   console.log( v.data.filter((i,index)=>index>=this.coordRange[0]&&index<=this.coordRange[1]))
      //  v.data.filter(i=>i>=this.coordRange[0]&&i<=this.coordRange[1]).forEach(k=>{
      //   num+=k

      //  })
      //   console.log(num)
      list.push({
        name: v.name,
        value: v.data.filter(
          (i, index) =>
            index >= this.coordRange[0] && index <= this.coordRange[1]
        ),
      });
    });
    this.selectList = list.map((obj) => ({
      name: obj.name,
      sum: obj.value.reduce((acc, cur) => acc + cur, 0) / obj.value.length,
    }));
  }
  public calculateAverage(arr) {
    let sum = 0;
    for (let i = 0; i < arr.length; i++) {
      sum += arr[i];
    }
    return sum / arr.length;
  }
  public calculateSum(arr) {
    let sum = 0;
    for (let i = 0; i < arr.length; i++) {
      sum += arr[i];
    }
    return sum;
  }
  public getFramesInfo(start, end) {
    let frameTimeList = this.cpu_by_frame.series[0].slice(start, end + 1);
    let frameTime = this.calculateAverage(frameTimeList);
    this.framesInfo.start = start;
    this.framesInfo.end = end;
    this.framesInfo.framesCount = frameTimeList.length;

    (this.framesInfo.sumTime as any) = this.calculateSum(frameTimeList).toFixed(
      2
    );
    (this.framesInfo.FPS as any) = (1000 / frameTime).toFixed(2);
    (this.framesInfo.frameTime as any) = frameTime.toFixed(2);
  }
  public cellStyle({ row, column, rowIndex, columnIndex }) {
    if (
      columnIndex === 0 ||
      columnIndex === 1 ||
      columnIndex === 2 ||
      rowIndex
    ) {
      //指定坐标rowIndex ：行，columnIndex ：列
      // this.getTableColor(row.depth)
      return "background:" + this.getTableColor(row.depth); //rgb(105,0,7)
    } else {
      return "";
    }
  }
  public handleCurrentChange(val) {
    this.currentPage = val;
    this.tableList_new = this.tableList.slice(
      (this.currentPage - 1) * 10,
      this.currentPage * 10
    );
  }
  public labelWallTime = (d, originalColor) => {
    if (this.flame_serch === "") {
      return originalColor;
    } else {
      return d.data.name
        .toUpperCase()
        .indexOf(this.flame_serch.toUpperCase()) != 0
        ? originalColor
        : "#E600E6";
    }
    // return  d.data.name.indexOf(this.flame_serch)!=0?originalColor : "#E600E6"
  };
  public recordSearch() {
    this.renderFlame("#chart", this.stackData_obj);
  }

  public async renderFlame(selector, data) {
    let flame: any = flamegraph();
    flame
      .width(1164)
      .label(this.labelTime)
      .setColorMapper(this.labelWallTime)
      .transitionDuration(1000);
    // .inverted(true);
    flame.onClick((node) => {
      // 点击事件处理函数
      this.func_name = node.data.name;
      this.func_rate = node.data.rate + "%";
      // this.flag = true;
      if (
        this.series_list.filter((v) => v.name == node.data.name).length == 0
      ) {
        dispatchDeepPerformanceTrendNode(store, {
          project: this.localProject,
          id_test: this.dataConsumeOptions.id_test,
          node_id: node.data.id,
        }).then((res) => {
          this.series_list.push({
            name: node.data.name,
            type: "line",

            showSymbol: false,

            itemStyle: {
              normal: {
                lineStyle: {
                  width: 1,
                },
              },
              emphasis: {
                lineStyle: {
                  width: 1, // hover时的折线宽度
                },
              },
            },
            yAxisIndex: 0,
            data: this.ratelist.map((item) => (item === null ? 0 : item)),
          });
          this.tableList_new.forEach((v) => {
            this.series_list.forEach((item) => {
              if (v.name == item.name) {
                v.check = true;
              }
            });
          });
          this.drawAnalyseTrend();
        });
        // this.ratelist = this.getFuncTrend(node.data.id);
      }

      // this.ratelist = this.getFuncTrend(node.data.id);
    });
    flame.onHover((node) => {
      this.func_name = node.data.name;
      this.func_rate = node.data.rate + "%";
    });
    d3.select(selector).datum(data).call(flame);
  }
  public renderFlame1(selector, data) {
    let flame = flamegraph();
    flame
      .width(1164)
      .setColorMapper(this.labelWallTime)
      .transitionDuration(1000);
    // .inverted(true);

    d3.select(selector).datum(data).call(flame);
  }
  public getTableColor(item) {
    let startColor = "#5D99D5";
    let endColor = "#C9EEFF";

    // var colorArr = this.gradient(startColor, endColor, 4);
    let colorArr = ["#62CDFF", "#97DEFF", "#C9EEFF", "#E9F8F9"];
    // console.log(colorArr)
    return colorArr[item];
  }
}
